import React from "react";
import type { HeadFC, PageProps } from "gatsby";
import {
  DirectoryContainer,
  RequestedSitesContainer,
  useApplication,
  DirectoryTab,
  DirectoryFilter,
  RequestedSitesFilter,
  Tabs,
  PAGE_CONTAINER_VARIANT,
  PageContainer,
} from "../components";

const IndexPage: React.FC<PageProps> = () => {
  const {
    state: { directoryTab },
    selectDirectoryTab,
  } = useApplication();

  const handleSelectTab = (id: string) => {
    if (id === DirectoryTab.PasskeySites) {
      selectDirectoryTab(DirectoryTab.PasskeySites);
    } else if (id === DirectoryTab.RequestedSites) {
      selectDirectoryTab(DirectoryTab.RequestedSites);
    }
  };

  return (
    <PageContainer variant={PAGE_CONTAINER_VARIANT.MAIN}>
      <Tabs
        tabs={[
          {
            id: DirectoryTab.PasskeySites,
            title: "Passkeys supported",
            header: <DirectoryFilter />,
            content: <DirectoryContainer />,
          },
          {
            id: DirectoryTab.RequestedSites,
            title: "Vote for passkeys support",
            header: <RequestedSitesFilter />,
            content: <RequestedSitesContainer />,
            badge: "NEW",
          },
        ]}
        activeTabId={directoryTab}
        onSelectTab={handleSelectTab}
      ></Tabs>
    </PageContainer>
  );
};

export default IndexPage;

export { Head } from "../components/Head";
